import { render } from "./activityTimeline2.vue?vue&type=template&id=60a46906"
import script from "./activityTimeline2.vue?vue&type=script&lang=js"
export * from "./activityTimeline2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__